<template>
  <div class="brand-graphic2">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 433.26 153.04">
      <path
        d="M5.96,140.41L75.91,70.48l70.67,70.64,69.95-69.93,69.2,69.17,70.49-70.46,71.07,71.04"
        fill="none"
        stroke-miterlimit="10"
        stroke-width="16.86"
      />
      <path
        d="M5.96,81.84L75.91,11.92l70.67,70.64L216.54,12.64l69.2,69.17"
        fill="none"
        stroke-miterlimit="10"
        stroke-width="16.86"
      />
    </svg>
  </div>
</template>
